export default __webpack_public_path__ + "static/media/automate-2.17841370.JPG";